import axios from "axios";
import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function PackPrice(){
    const [packcats,setpackcats] = useState([]);
    const [insur,setInsur] = useState([]);
    const [PackPrice, setPackPrice] = useState([]);
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [priceData,setpriceData]=useState({
        "packcat":'',
        "packsubcat":'',
        "amount":'',
        "status":'',
        "addedby":'',
        "ip_add":''
    });

    const handleChange = (event) => {
        setpriceData({
            ...priceData,
            [event.target.name]:event.target.value
        });
    }

    const formSubmit = () =>{
        const _formData = new FormData();
        _formData.append('pack',priceData.cat_id);
        _formData.append('insur',priceData.insur_id);
        _formData.append('amount',priceData.amount);
        _formData.append('status','1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
        try{
            axios.post(baseUrl+'create-pack-price/', _formData, {
                headers : {
                    'content-type': 'multiple/form-data'
                }
            })
            .then(function (response) {
               if(response.status==200 || response.status==201){
                    Swal.fire({
                        title: 'Data has been updated',
                        icon: 'success',
                        timer:5000,
                        showConfirmButton: false
                    });

               }
               setTimeout(() => {
                        window.location.href = ('/pack-price');
                        }, 3000);
            });
            }catch(error){
                console.log(error);
            }
        };

    useEffect(() => {
        try{
            axios.get(baseUrl+'create-pack/')
            .then(function (response) {
                setpackcats(response.data);
            });
        }catch(error){
            console.log(error);
        }
        try{
            axios.get(`${baseUrl}insur-cmpy/`)
      .then(response => {
        setInsur(response.data);
      })
        }catch(error){
            console.log(error);
        }
        },[]);
useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
      if (PackPrice.length > 0) {
        setRows(PackPrice);
      }
  }, [PackPrice]);
  function fetchData() {
    setIsLoading(true);
    axios.get(`${baseUrl}create-pack-price/`)
      .then(response => {
        setPackPrice(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-pack-price/'+id)
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                      setTimeout(() => {
                        window.location.href = ('/pack-price');
                        }, 3000);
                    });
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }
  const columns = [
  {
    field: 'pack',
    headerName: 'Pack SubCategory',
    width: 400,
    renderCell: (params) => {
      // safely access packsubcat
      return params.row.pack ? params.row.pack.packsubcat : 'N/A';
    },
  },
  {
    field: 'insur',
    headerName: 'Insurance Company',
    width: 300,
    renderCell: (params) => {
      // safely access company name
      return params.row.insur ? params.row.insur.company : 'N/A';
    },
  },
  {
    field: 'amount',
    headerName: 'Amount',
    width: 100,
  },
  {
    field: 'addedby',
    headerName: 'Added By',
    width: 100,
  },
  {
    field: 'edit',
    headerName: 'Edit',
    width: 120,
    renderCell: (params) => (
      <Link to={`/edit-packprice/${params.row.id}`} className="btn btn-warning" target="_blank">
        Edit
      </Link>
    ),
  },
  {
    field: 'delete',
    headerName: 'Action',
    width: 120,
    renderCell: (params) => (
      <button onClick={() => handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
        <i className="fa-solid fa-trash-can"></i>
      </button>
    ),
  },
];

    return (
        <section className="container mt-4">
            <div className="row">
              <div className='col-md-9 col-12 mb-2'>
                <div className='card'>
                    <h4 className='card-header'>Add Package Price</h4>
                    <div className='card-body'>
                        <form>
                        <div className="mb-3">
                            <label htmlFor="cat_id" className="form-label">Package SubCategory</label>
                            <select name="cat_id" value={priceData.cat_id} onChange={handleChange} className="form-control">
                            <option>Choose Package SubCategory </option>
                                {packcats.map((category,index) => {return <option key={index} value={category.id}>{category.packsubcat}
                                </option>})}
                            </select>
                          </div>
                          <div className="mb-3">
                            <label htmlFor="insur_id" className="form-label">Insurance</label>
                            <select name="insur_id" value={priceData.insur_id} onChange={handleChange} className="form-control">
                            <option>Choose Insurance</option>
                                {insur.map((insurer,index) => {return <option key={index} value={insurer.id}>
                                {insurer.company}
                                </option>})}
                            </select>
                          </div>

                          <div className="mb-3">
                            <label htmlFor="amount" className="form-label">Amount</label>
                            <input type="number" className="form-control" name="amount" value={priceData.amount}
                            onChange={handleChange} id="amount" required/>
                          </div>

                          <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                        </form>
                    </div>
                </div>
              </div>
            </div>
                    <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            pageSize={28}
            rows={rows}
            columns={columns}
            components={{
                Toolbar: GridToolbar,
             }}
            autoHeight
          />
          </div>

        </section>

)
}

export default PackPrice;